import React, {useState} from 'react';
import {Checkbox, DatePicker, Divider, Input, Modal, Typography} from 'antd';
import Photos from "./leasePhotos";
import * as moment from 'moment';

const {TextArea} = Input;
const {Title, Paragraph, Text} = Typography;

export const InfoModel = (props) => {

  const {info, code, closeDescription, isVisible, updateDescription, updatedLeaseInfo, loading} = props;
  const [show, setShow] = useState(false);
  const [desc, setDesc] = useState(info.description ? info.description : '');
  const [initialLeaseStartDate, setInitialLeaseStartDate] = useState(info.initialLeaseStartDate ? info.initialLeaseStartDate : '');

  const handleCancel = e => {
    closeDescription();
  };

  const handelOk = _ => {
    // console.log(desc, initialLeaseStartDate);
    updateDescription(desc, initialLeaseStartDate);
  };

  const toggleEdit = (e) => {
    e.target.checked ? setShow(true) : setShow(false);
  };

  const noContent = (<div>
    <h3 style={{color: 'tomato'}}>No lease description, add now.</h3>
    <Divider/>
    <Checkbox onChange={toggleEdit}> Edit </Checkbox>
  </div>);

  const content = (
    <div>
      <TextArea onChange={e => setDesc(e.target.value)} autoSize={{minRows: 3, maxRows: 5}}
                defaultValue={desc}/>
      <Divider/>
      <div style={{paddingBottom: 10}}>
        Initial leasing Start Date :
        <DatePicker style={{float: 'right'}} onChange={value => setInitialLeaseStartDate(value)}
                    defaultValue={initialLeaseStartDate ? moment(initialLeaseStartDate) : null}
                    format={'YYYY-MM-DD'}/>
      </div>
      <Divider/>
      <Checkbox onChange={toggleEdit}> Edit </Checkbox>
    </div>
  );
  const viewContent = info ? (
    <div>
      <Typography>
        <Paragraph>
          {desc}
        </Paragraph>
      </Typography>
      <Typography>
        <Paragraph>
          Initial leasing Start Date : {initialLeaseStartDate ? moment(initialLeaseStartDate).format('DD-MM-YYYY') : 'NA'}
        </Paragraph>
      </Typography>
      <Divider/>
      <Checkbox onChange={toggleEdit}> Edit </Checkbox>
      <Divider/>
      {<Photos images={info.images ? info.images : []} {...props}/>}
    </div>) : noContent;

  const title = <h3>{`Asset leasing information for ${code}`}</h3>

  return (
    <Modal
      title={title}
      visible={isVisible}
      onOk={handelOk}
      onCancel={handleCancel}
      okText="Update"
      okButtonProps={{disabled: !show, loading: loading}}
    >
      {show ? content : viewContent}
    </Modal>
  );
};

export default InfoModel;
